module.exports = {
  name: "ISEA Virtual Platform",
  desc: "IVP - ISEA Virtual Platform",
  prefix: "IVP",
  footerText: "CDAC",
  logoText: "ISEA Virtual Platform",
  image: "/app/images/logo/ivplogo.png",
};
